import * as React from 'react';
import { makeCSS } from '../../../utils/makeCSS';
import { Icon, IconName } from '../Icon';
import { SizeVariants } from '../../../theme/themes';
import { Typography } from '../Typography';
import Truncate from '../../utility/Truncate';
import { CubeAnchorLink } from '../CubeAnchorLink';
/**Visual indicator of the Project that the notification is referring to.
 * Its being used by the NotificationItem (Part of the activity feed.)
 */

export interface InlineProjectProps {
  icon?: IconName;
  /**Name of the progect */
  projectName?: string;
  onClick?(e: React.MouseEvent): void;
  projectHref: string;
}

const useCSS = makeCSS(({ theme }) => {
  return {
    root: {
      display: 'inline-flex',
      alignItems: 'center',
      gap: theme.spacing[1],
      width: 'fit-content',
      height: theme.spacing[5]
    },
    projectThumbnail: {
      display: 'flex',
      width: theme.spacing[7],
      height: theme.spacing[4],
      justifyContent: 'center',
      alignItems: 'center',
      borderRadius: theme.borderRadius.sm,
      border: `1px solid ${theme.color.line['03']}`,
      background: theme.color.overlay['01']
    },
    projectName: {
      display: 'flex',
      justifyContent: 'center',
      maxWidth: theme.spacing[36]
    },
    cursorStyle: {
      cursor: 'pointer'
    }
  };
});

export const InlineProject = (props: InlineProjectProps) => {
  const {
    icon = 'project',
    projectName = 'Project',
    onClick,
    projectHref
  } = props;

  const classes = useCSS(props);

  return (
    <div className={`${classes.root}`}>
      <span className={`${classes.projectThumbnail}`}>
        <Icon icon={icon} size={SizeVariants.sm} colorVariant="01" />
      </span>
      <span className={`${classes.projectName}`}>
        {onClick ? (
          <Typography variant="md" colorVariant="03">
            <CubeAnchorLink
              href={projectHref}
              onLinkClick={onClick}
              injectedClassName={classes.cursorStyle}
            >
              <Truncate str={projectName} widthLimit={150} />
            </CubeAnchorLink>
          </Typography>
        ) : (
          <Typography variant="md" colorVariant="03">
            <Truncate str={projectName} widthLimit={150} />
          </Typography>
        )}
      </span>
    </div>
  );
};
